// extracted by mini-css-extract-plugin
module.exports = {"validity_options":"styles_validity_options__39b5y","valid":"styles_valid__3WweX","critic":"styles_critic__3yF13","invalid":"styles_invalid__1WSX9","active":"styles_active__EeSLK"};